import React, { useState } from "react";
import {
  ButtonsWrapper,
  CustomHelpIcon,
  CardContainer,
  DateTimeWrapper,
  DetailLabel,
  DetailWrapper,
  HelpContainer,
  HelpIcon,
  HelpTooltip,
  HelpTrigger,
  LeftContainer,
  MainContainer,
  ReservationDetailsWrapper,
  ResourceName,
  RightContainer,
  RowWrapper,
  StarContainer,
  ValueLabel,
  ButtonContainer,
} from "./styles";
import { Button, Icon, IconButton } from "@mui/material";
import { Delete, Edit, Help, Star, StarBorder } from "@mui/icons-material";
import { SingleGallery } from "../SingleGallery";
import { ReservationCardProps } from "./types";
import theme from "../../theme/theme";
import { EditReservationModal } from "../../pages/EditReservationModal/EditReservationModal";
import DeleteReservationModal from "../../pages/DeleteReservationModal/DeleteReservationModal";
import { postFavourite } from "../../services/favourites/postFavourites";
import { deleteFavourite } from "../../services/favourites/deleteFavourites";
import { getFavouritesList } from "../../services/favourites/getFavourites";
import { getResourceById } from "../../services/resources/getResources";

const ReservationCard: React.FC<ReservationCardProps> = ({
  width = "70%",
  height = "auto",
  reservation,
}) => {
  const jwt = localStorage.getItem("jwt");

  // ------------------- STATES -------------------
  const [isFavorite, setIsFavorite] = React.useState(false);
  const [starColor, setStarColor] = useState("#D0CCC6");
  const [serverResponse, setServerResponse] = React.useState(false); // Server response state
  const [favouritesList, setFavouritesList] = React.useState<any>([]); // Favourites list state
  const [img, setImg] = React.useState<any>([]); // Favourites list state
  const [loading, setLoading] = React.useState(false); // Loading state
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);


  // ------------------- USE EFFECT -------------------
  React.useEffect(() => {
    setStarColor(!isFavorite ? "#D0CCC6" : "#F2A007");
  }, [isFavorite]);

  React.useEffect(() => {
    getFavourites();
    getResource();
  }, []);

  React.useEffect(() => {
    const handleWindowResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);

  // ------------------- GET RESOURCES FROM API -------------------
  const getFavourites = async () => {
    await getFavouritesList(jwt!)
      .then((res) => {
        if (res && res.data) {
          setFavouritesList(res.data.favourites_list);
          res.data.favourites_list.find((fav: any) => fav.id === reservation.resourceId)
            ? setIsFavorite(true)
            : setIsFavorite(false);
        }
      })
      .catch((err) => {});
  };

  const postFavouriteById = async (token: string, id: number) => {
    await postFavourite(token, id)
      .then((res) => {
        if (res && res.data) {
          if (res.status !== 200) {
            setServerResponse(false);
          } else {
            setServerResponse(true);
          }
        }
      })
      .catch((err) => {
        setServerResponse(true);
      });
  };

  const deleteFavouriteById = async (token: string, id: number) => {
    await deleteFavourite(token, id)
      .then((res) => {
        if (res && res.data) {
          if (res.status !== 200) {
            setServerResponse(false);
          } else {
            setServerResponse(true);
          }
        }
      })
      .catch((err) => {
        setServerResponse(true);
      });
  };

  const getResource = async () => {
    await getResourceById(reservation.resourceId, jwt!)
      .then((res) => {
        if (res && res.data) {
          setImg(res.data.resource.images);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err, "err");
      });
  };

  const handleStarClick = (e?: React.MouseEvent<HTMLButtonElement>) => {
    if (!isFavorite) {
      postFavouriteById(jwt!, reservation.resourceId!);
    } else {
      deleteFavouriteById(jwt!, reservation.resourceId!);
    }
    setIsFavorite(!isFavorite);
  };

  const images=[
    "https://pa1.aminoapps.com/6707/510b0daee67fbc091f14b9d8ef40aeb6c0d4dc7d_hq.gif",
    "https://pa1.aminoapps.com/6707/510b0daee67fbc091f14b9d8ef40aeb6c0d4dc7d_hq.gif",
    "https://pa1.aminoapps.com/6707/510b0daee67fbc091f14b9d8ef40aeb6c0d4dc7d_hq.gif",
    "https://pa1.aminoapps.com/6707/510b0daee67fbc091f14b9d8ef40aeb6c0d4dc7d_hq.gif",
    "https://pa1.aminoapps.com/6707/510b0daee67fbc091f14b9d8ef40aeb6c0d4dc7d_hq.gif",
  ]

  const isMobile = windowWidth <= 400;

  return (
    <CardContainer width={width} height={height}>
      <StarContainer>
        <IconButton onClick={handleStarClick}>
          <Star
            sx={{
              color: starColor,
              fontSize: "40px",
              cursor: "pointer",
            }}
          />
        </IconButton>
      </StarContainer>
      <MainContainer>
        <LeftContainer>
          <SingleGallery
            width={isMobile ? "100%" : "450px"}
            height={isMobile ? "auto" : "300px"}
            images={
              !loading
                  ? img.map((img: any) => img.url)
                  : images
            }
          />
        </LeftContainer>
        <RightContainer>
          <ResourceName>{reservation.resourceName}</ResourceName>
          <ReservationDetailsWrapper>
            <RowWrapper>
              <DetailLabel>Fecha de inicio</DetailLabel>
              <DateTimeWrapper>
                <ValueLabel>{reservation.startDate}</ValueLabel>
                <ValueLabel>{reservation.startTime} hrs</ValueLabel>
              </DateTimeWrapper>
            </RowWrapper>
            <RowWrapper>
              <DetailLabel>Fecha de fin</DetailLabel>
              <DateTimeWrapper>
                <ValueLabel>{reservation.endDate}</ValueLabel>
                <ValueLabel>{reservation.endTime} hrs</ValueLabel>
              </DateTimeWrapper>
            </RowWrapper>
            <RowWrapper>
              <DetailWrapper>
                <DetailLabel>Estado</DetailLabel>
                <HelpContainer>
                  <HelpIcon>
                    <CustomHelpIcon />
                  </HelpIcon>
                  <HelpTooltip>
                    <p>
                      <strong>Finalizada:</strong> La reservación ha concluido.
                    </p>
                    <p>
                      <strong>En progreso:</strong> La reservación está en
                      curso.
                    </p>
                    <p>
                      <strong>Pendiente:</strong> La reservación está siendo
                      validada.
                    </p>
                    <p>
                      <strong>Aprobada:</strong> La reservación ha sido
                      autorizada.
                    </p>
                    <p>
                      <strong>Denegada:</strong> La reservación no fue
                      autorizada.
                    </p>
                    <p>
                      <strong>No disponible:</strong> El horario seleccionado no
                      está disponible.
                    </p>
                    <p>
                      <strong>Cancelada:</strong> La reservación ha sido
                      cancelada.
                    </p>
                    <p>
                      <strong>Vencida:</strong> El periodo de tiempo para aprobación ha expirado.
                    </p>
                  </HelpTooltip>
                </HelpContainer>
              </DetailWrapper>
              <ValueLabel>{reservation.status}</ValueLabel>
            </RowWrapper>
          </ReservationDetailsWrapper>
          <ButtonsWrapper>
            <ButtonContainer>
              {reservation.status &&
                ![
                  "Completada",
                  "No disponible",
                  "Denegada",
                  "Cancelada",
                  "Modificada",
                  "Desconocido",
                  "Vencida",
                ].includes(reservation.status) && (
                  <EditReservationModal
                    id={reservation.reservationId}
                    resource={reservation.resourceId}
                    currentStartDate={reservation.startDate}
                    currentStartTime={reservation.startTime}
                    currentEndDate={reservation.endDate}
                    currentEndTime={reservation.endTime}
                    currentDescription={reservation.description}
                  />
                )}
            </ButtonContainer>
            <ButtonContainer>
              {reservation.status &&
                ![
                  "Completada",
                  "No disponible",
                  "Denegada",
                  "Cancelada",
                  "Modificada",
                  "Desconocido",
                  "Vencida",
                ].includes(reservation.status) && (
                  <DeleteReservationModal
                    reservationId={reservation.reservationId}
                  />
                )}
            </ButtonContainer>
          </ButtonsWrapper>
        </RightContainer>
      </MainContainer>
    </CardContainer>
  );
};

export default ReservationCard;
